var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.navegavel ? "button" : "div",
    {
      tag: "component",
      class: _vm.classeRaiz,
      attrs: { type: _vm.navegavel ? "button" : null },
      on: { click: _vm.aoClicar }
    },
    [
      _c(
        "div",
        { staticClass: "ia-insight__rotulo ia-texto-selo" },
        [
          _c("span", [_vm._v(_vm._s(_vm.rotulo))]),
          _vm.navegavel
            ? _c("icon-svg", {
                attrs: {
                  name: "arrow-left",
                  size: _vm.TAMANHO_CHEVRON,
                  color: "var(--neutral-600)"
                }
              })
            : _vm._e(),
          _vm.semFonteDeDado && _vm.variante !== "compacto"
            ? _c(
                "span",
                {
                  staticClass:
                    "ia-insight__sem-dado ia-texto-auxiliar ia-insight__sem-dado--inline"
                },
                [_vm._v(_vm._s(_vm.mensagemSemDado))]
              )
            : !_vm.semFonteDeDado && _vm.ehProgresso
            ? _c(
                "span",
                { staticClass: "ia-insight__contador ia-texto-auxiliar" },
                [
                  _vm.carregando
                    ? _c(
                        "BaseLoadingSkeleton",
                        _vm._b(
                          {},
                          "BaseLoadingSkeleton",
                          _vm.CAIXA.contador,
                          false
                        )
                      )
                    : [_vm._v(_vm._s(_vm.valor))]
                ],
                2
              )
            : !_vm.semFonteDeDado && _vm.valorNoRotulo
            ? _c("span", { staticClass: "ia-insight__resumo" }, [
                _c(
                  "span",
                  { staticClass: "ia-insight__valor ia-texto-numero-destaque" },
                  [
                    _vm.carregando
                      ? _c(
                          "BaseLoadingSkeleton",
                          _vm._b(
                            {},
                            "BaseLoadingSkeleton",
                            _vm.CAIXA.valor,
                            false
                          )
                        )
                      : [_vm._v(_vm._s(_vm.valor))]
                  ],
                  2
                ),
                _c(
                  "span",
                  { staticClass: "ia-insight__aux ia-texto-auxiliar" },
                  [
                    _vm.carregando
                      ? _c(
                          "BaseLoadingSkeleton",
                          _vm._b(
                            {},
                            "BaseLoadingSkeleton",
                            _vm.CAIXA.aux,
                            false
                          )
                        )
                      : [
                          _vm.destaque
                            ? _c(
                                "strong",
                                { style: { color: _vm.corDoDestaque } },
                                [_vm._v(_vm._s(_vm.destaque))]
                              )
                            : _vm._e(),
                          _vm._v(" " + _vm._s(_vm.legenda) + " ")
                        ]
                  ],
                  2
                )
              ])
            : _vm._e()
        ],
        1
      ),
      !_vm.semFonteDeDado
        ? [
            _vm.variante === "hero"
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "ia-insight__linha ia-insight__linha--entre"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "ia-insight__valor ia-insight__valor--hero ia-texto-titulo-cartao"
                        },
                        [
                          _vm.carregando
                            ? _c(
                                "BaseLoadingSkeleton",
                                _vm._b(
                                  {},
                                  "BaseLoadingSkeleton",
                                  _vm.CAIXA.valorHero,
                                  false
                                )
                              )
                            : [_vm._v(_vm._s(_vm.valor))]
                        ],
                        2
                      ),
                      _vm.carregando
                        ? _c(
                            "span",
                            {
                              staticClass: "ia-insight__aux ia-texto-auxiliar"
                            },
                            [
                              _c(
                                "BaseLoadingSkeleton",
                                _vm._b(
                                  {},
                                  "BaseLoadingSkeleton",
                                  _vm.CAIXA.aux,
                                  false
                                )
                              )
                            ],
                            1
                          )
                        : _vm.destaque || _vm.legenda
                        ? _c(
                            "span",
                            {
                              staticClass: "ia-insight__aux ia-texto-auxiliar"
                            },
                            [
                              _vm.destaque
                                ? _c(
                                    "strong",
                                    { style: { color: _vm.corDoDestaque } },
                                    [_vm._v(_vm._s(_vm.destaque))]
                                  )
                                : _vm._e(),
                              _vm._v(" " + _vm._s(_vm.legenda) + " ")
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm.faixas.length
                    ? _c(
                        "div",
                        { staticClass: "ia-insight__faixas" },
                        _vm._l(_vm.faixas, function(f) {
                          return _c("span", { key: f.chave, style: f.estilo })
                        }),
                        0
                      )
                    : _vm._e()
                ]
              : _vm.variante === "escala"
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "ia-insight__trilho",
                      class: { "ia-insight__trilho--pendente": _vm.carregando }
                    },
                    [
                      !_vm.carregando
                        ? _c("span", {
                            staticClass: "ia-insight__marcador",
                            style: { left: _vm.posicaoDoMarcador + "%" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "ia-insight__bandas ia-texto-micro" },
                    _vm._l(_vm.bandas, function(b) {
                      return _c(
                        "span",
                        {
                          key: b.rotulo,
                          class: { "ia-insight__banda--ativa": b.ativa },
                          style: b.estilo
                        },
                        [_vm._v(_vm._s(b.rotulo))]
                      )
                    }),
                    0
                  )
                ]
              : _vm.variante === "serie"
              ? [
                  _c(
                    "div",
                    { staticClass: "ia-insight__serie-corpo" },
                    [
                      _c("div", { staticClass: "ia-insight__serie-texto" }, [
                        _c(
                          "div",
                          { staticClass: "ia-insight__linha" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "ia-insight__valor ia-texto-numero-destaque"
                              },
                              [
                                _vm.carregando
                                  ? _c(
                                      "BaseLoadingSkeleton",
                                      _vm._b(
                                        {},
                                        "BaseLoadingSkeleton",
                                        _vm.CAIXA.valor,
                                        false
                                      )
                                    )
                                  : [_vm._v(_vm._s(_vm.valor))]
                              ],
                              2
                            ),
                            _vm.carregando
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "ia-insight__aux ia-texto-auxiliar"
                                  },
                                  [
                                    _c(
                                      "BaseLoadingSkeleton",
                                      _vm._b(
                                        {},
                                        "BaseLoadingSkeleton",
                                        _vm.CAIXA.auxSerieDestaque,
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              : _vm.destaque
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ia-insight__serie-destaque",
                                    style: {
                                      color: _vm.corDoDestaque,
                                      background: _vm.fundoDoDestaque
                                    },
                                    attrs: { "x-small": "" }
                                  },
                                  [_vm._v(_vm._s(_vm.destaque))]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm.carregando
                          ? _c(
                              "span",
                              {
                                staticClass: "ia-insight__aux ia-texto-auxiliar"
                              },
                              [
                                _c(
                                  "BaseLoadingSkeleton",
                                  _vm._b(
                                    {},
                                    "BaseLoadingSkeleton",
                                    _vm.CAIXA.auxSerieLegenda,
                                    false
                                  )
                                )
                              ],
                              1
                            )
                          : _vm.legenda
                          ? _c(
                              "span",
                              {
                                staticClass: "ia-insight__aux ia-texto-auxiliar"
                              },
                              [_vm._v(_vm._s(_vm.legenda))]
                            )
                          : _vm._e()
                      ]),
                      _c("IaSparkline", {
                        staticClass: "ia-insight__serie-grafico",
                        attrs: { serie: _vm.serie, fantasma: _vm.carregando }
                      })
                    ],
                    1
                  )
                ]
              : _vm.variante === "progresso"
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "ia-insight__barra",
                      class: { "ia-insight__barra--pendente": _vm.carregando }
                    },
                    [_c("span", { style: _vm.larguraPendente })]
                  ),
                  _vm.carregando
                    ? _c(
                        "div",
                        { staticClass: "ia-insight__aux ia-texto-auxiliar" },
                        [
                          _c(
                            "BaseLoadingSkeleton",
                            _vm._b(
                              {},
                              "BaseLoadingSkeleton",
                              _vm.CAIXA.aux,
                              false
                            )
                          )
                        ],
                        1
                      )
                    : _vm.destaque || _vm.legenda
                    ? _c(
                        "div",
                        { staticClass: "ia-insight__aux ia-texto-auxiliar" },
                        [
                          _vm.destaque
                            ? _c(
                                "strong",
                                { style: { color: _vm.corDoDestaque } },
                                [_vm._v(_vm._s(_vm.destaque))]
                              )
                            : _vm._e(),
                          _vm._v(" " + _vm._s(_vm.legenda) + " ")
                        ]
                      )
                    : _vm._e()
                ]
              : [
                  _c(
                    "div",
                    {
                      staticClass: "ia-insight__valor ia-texto-numero-destaque"
                    },
                    [
                      _vm.carregando
                        ? _c(
                            "BaseLoadingSkeleton",
                            _vm._b(
                              {},
                              "BaseLoadingSkeleton",
                              _vm.CAIXA.valor,
                              false
                            )
                          )
                        : [
                            _vm._v(" " + _vm._s(_vm.valor) + " "),
                            _vm.unidade
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "ia-insight__unidade ia-texto-auxiliar"
                                  },
                                  [_vm._v(_vm._s(_vm.unidade))]
                                )
                              : _vm._e()
                          ]
                    ],
                    2
                  ),
                  _vm.pontosDecorados.length
                    ? _c(
                        "div",
                        {
                          staticClass: "ia-insight__pontos",
                          class: {
                            "ia-insight__pontos--pendente": _vm.carregando
                          }
                        },
                        _vm._l(_vm.pontosDecorados, function(p) {
                          return _c("span", { key: p.chave, style: p.estilo })
                        }),
                        0
                      )
                    : _vm.barrasDecoradas.length
                    ? _c(
                        "div",
                        {
                          staticClass: "ia-insight__barrinhas",
                          class: {
                            "ia-insight__barrinhas--pendente": _vm.carregando
                          }
                        },
                        _vm._l(_vm.barrasDecoradas, function(b) {
                          return _c("span", { key: b.chave, style: b.estilo })
                        }),
                        0
                      )
                    : _vm.faixas.length
                    ? _c(
                        "div",
                        { staticClass: "ia-insight__faixas" },
                        _vm._l(_vm.faixas, function(f) {
                          return _c("span", { key: f.chave, style: f.estilo })
                        }),
                        0
                      )
                    : _vm._e()
                ]
          ]
        : _vm.variante === "compacto"
        ? _c("div", { staticClass: "ia-insight__sem-dado ia-texto-auxiliar" }, [
            _vm._v(" " + _vm._s(_vm.mensagemSemDado) + " ")
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }